import React from 'react';
import { observer } from 'mobx-react';
import { NikoInsuranceManagementListTemplate } from 'themes/application/niko-insurance-management/pages';
import { setCurrentView } from 'core/utils';
import { NikoInsuranceManagementListViewStore } from 'application/niko-insurance-management/stores';

@setCurrentView((rootStore) => new NikoInsuranceManagementListViewStore(rootStore), 'nikoInsuranceManagementListViewStore')
@observer
class NikoInsuranceManagementList extends React.Component {
    render() {
        return <NikoInsuranceManagementListTemplate {...this.props} />
    }
}

export default NikoInsuranceManagementList;